<!--
    Use type="text" + inputmode="decimal" instead of type="number"
    because browsers don't allow programmatic comma insertion in number inputs.
    inputmode="decimal" still shows the numeric keyboard on mobile devices.
  -->
<input type="text" inputmode="decimal" autocomplete="off" [placeholder]="placeholder" [class]="inputClass"
    [class.is-invalid]="isInvalid" [disabled]="isDisabled" [value]="displayValue" (input)="onInput($event)"
    (blur)="onBlur()" (paste)="onPaste($event)" (keydown)="onKeyDown($event)"/>